import { useState } from 'react';
import { ResultFeedbackSection } from 'widgets/results/ResultFeedbackSection';
import { FeedbackOverlay } from 'widgets/results/FeedbackOverlay';

interface ResultFeedbackWidgetProps {
  interactionId?: string;
}

export function ResultFeedbackWidget({ interactionId }: ResultFeedbackWidgetProps) {
  const [showFeedbackDialog, setShowFeedbackDialog] = useState(false);
  const [initialFeedbackHelpful, setInitialFeedbackHelpful] = useState<boolean>();
  const [lastSubmittedHelpful, setLastSubmittedHelpful] = useState<boolean>();

  return (
    <>
      <ResultFeedbackSection
        onOpenFeedback={(isHelpful) => {
          setInitialFeedbackHelpful(isHelpful);
          setShowFeedbackDialog(true);
        }}
        lastSubmittedHelpful={lastSubmittedHelpful}
      />
      <FeedbackOverlay
        isVisible={showFeedbackDialog}
        setShowFeedbackDialog={setShowFeedbackDialog}
        interactionId={interactionId}
        triggerType="manual"
        initialHelpful={initialFeedbackHelpful}
        onSubmitted={(helpful: boolean) => {
          setLastSubmittedHelpful(helpful);
        }}
      />
    </>
  );
}
